import { lightTextPlaceholder } from "constants/colors";
import { BREAKPOINT_DESKTOP, BREAKPOINT_TABLET } from "constants/constants";
import styled from "styled-components/macro";
const CURRENT_COUNT_LABEL_WIDTH = 174;

export const AheadBehindSummaryChartsStyles = styled.div<{
  $isCompactLayout: boolean;
}>`
  justify-content: center;
  display: flex;
  flex-direction: column;
  text-align: center;
  .space {
    height: 80px;
  }
  .progressSummaries {
    margin: 0;
    display: flex;
    flex-direction: column;
  }
  .info {
    display: flex;
    flex-direction: column;
    align-items: center;
    @media (min-width: ${BREAKPOINT_DESKTOP}px) {
      &.operatorMetricInfo:first-child {
        margin-top: 32px;
      }
    }
    &.targetCountInfo {
      margin-top: 16px;
      color: ${lightTextPlaceholder};
    }
    .countLabel {
      font-family: "Open Sans";
      font-size: 14px;
      width: ${CURRENT_COUNT_LABEL_WIDTH}px;
      &.middle {
        margin: 0 16px;
      }
    }
    .count {
      font-family: "Open Sans";
      font-size: 24px;
      flex-grow: 1;
      flex-shrink: 0;
      width: 0;
    }
  }
  @media (min-width: ${BREAKPOINT_TABLET}px) {
    .space {
      height: 0;
      width: ${props => (props.$isCompactLayout ? 124 : 216)}px;
    }
    .progressSummaries {
      flex-direction: row;
    }
    .info {
      .countLabel {
        white-space: nowrap;
        font-size: 24px;
        display: flex;
        justify-content: center;
      }
      flex-direction: row;
      &.operatorMetricInfo:first-child {
        margin-top: 38px;
      }
      &.targetCountInfo {
        margin-top: 8px;
      }
    }
  }
`;
